import { useTranslate } from '@hd/i18n/useTranslate';
import { formatDate, getNightsBetweenDates } from '@hd/utils/dates';

function StayTableCell({
  checkIn,
  checkOut,
  channelName,
  quotationCode
}: {
  checkIn?: Date;
  checkOut?: Date;
  channelName?: string;
  quotationCode?: string;
}) {
  const t = useTranslate();
  return (
    <div className="flex items-start">
      <div className="ml-1">
        {checkIn && checkOut && (
          <div>
            <b>{formatDate(checkIn, "eee dd LLL y")} - {formatDate(checkOut, "eee dd LLL y")}</b> ({getNightsBetweenDates(checkIn, checkOut)} notti)
          </div>
        )}
        {channelName && (
          <div>
            <b>{t("common.channel")}</b>: <span className="text-accent">{channelName}</span>
          </div>
        )}
        {quotationCode && (
          <div>
            <b>{t("common.code")}</b>: {quotationCode}
          </div>
        )}
      </div>
    </div>
  );
}

export default StayTableCell;
